import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'

import classnames from 'classnames'

const RiderNavigation = (props) => {
  const { sections } = props

  const className = (section) => classnames({
    'active': section === props.activeSection
  })

  return (
    <nav className="rider-navigation">
      <ul>
        {
          sections.map((section, index) => (
            <li key={index}><a className={className(section.slug)} onClick={() => props.scrollTo(section.slug)}>{section.title}</a></li>
          ))
        }
      </ul>
    </nav>
  )
}

RiderNavigation.propTypes = {
  sections: PropTypes.array,
  riderId: PropTypes.string,
  activeSection: PropTypes.string,
  scrollTo: PropTypes.func
}

RiderNavigation.defaultProps = {
  sections: [],
  riderId: '',
  activeSection: undefined,
  scrollTo: function() {}
}

export default RiderNavigation



// WEBPACK FOOTER //
// ./src/components/rider/rider-navigation.js